import { setScreenRules, setUserPolicies } from '@showtime/cea-dep-permissions';

export const initPermissionsService = (policies = [], screenRules = []) => {
  setUserPolicies(policies);
  setScreenRules(screenRules);
};
